import { ExecuteLayoutEventMethods } from "../../../General/commonFunctions";

const FactsForm = (props) => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    await ExecuteLayoutEventMethods(props?.onSubmit, props, null, null);
  };

  return (
    <form id={props?.id || "factsFormWrapper"} onSubmit={handleSubmit}>
      {props.children}
    </form>
  );
};

export default FactsForm;
